module.exports = __webpack_public_path__ + "8d4ea85150cafbc0f0baa317b0930ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/sarah-drasner.jpg
// module id = 453
// module chunks = 0